export const keyboardTiming = {
	delayToRemoveAfterClose: 0, //200
	delayToActiveAfterOpen: 0 //100
};

export const TIMEOUT_FOR_MIMICING_STOP_PROPAGATION = 10;

export const LOADING_FOR_AUTHENTICATION_MS = 3000;

export const DELAY_FOR_GETTING_COMMISSIONS_MS = 5000;

export const DELAY_FOR_SEARCH_STOCK = 500;
